import { Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BehaviorSubject, Observable, Subject, Subscription, combineLatest, map, of, startWith, takeUntil, tap } from 'rxjs';
import { IProduct, ISupplierProduct, IVariant,IFile, ICurrencyPrice} from '../../models/products.models';
import { MatDialog } from '@angular/material/dialog';
import { AddElementsComponent } from '../add-elements/add-elements.component';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { AddProduct, AddProductSuccess, AddProductWithVariants, AddProductWithVariantsSuccess, GetProductById, GetProductByIdError, GetProductByIdSuccess, ImproveVariantsProduct, ImproveVariantsProductError, ImproveVariantsProductSuccess, UpdateProduct, UpdateProductSuccess, UpdateVariantsProduct } from '../../store/produits.actions';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Actions, ofType } from '@ngrx/effects';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { AddCategoryError, AddCategorySuccess, FetchAllCategories } from 'src/app/features/categories/store/categories.actions';
import { ITag } from 'src/app/features/tags/models/tags.models';
import { AddTagError, AddTagSuccess, FetchAllTags } from 'src/app/features/tags/store/tags.actions';
import { IBrand } from 'src/app/features/brands/models/brands.models';
import { AddBrandError, AddBrandSuccess, FetchAllBrands } from 'src/app/features/brands/store/brands.actions';
import { ICatalog, IGeneralRules } from 'src/app/features/catalogs/models/catalogs.models';
import { MatStepper } from '@angular/material/stepper';
import { FetchAllCatalogs } from 'src/app/features/catalogs/store/catalogs.actions';
import { EditBasicProductInfoComponent } from '../edit-basic-product-info/edit-basic-product-info.component';
import { EditProductPricingComponent } from '../edit-product-pricing/edit-product-pricing.component';
import { EditProductInventoryComponent } from '../edit-product-inventory/edit-product-inventory.component';
import { EditProductOrganizeComponent } from '../edit-product-organize/edit-product-organize.component';
import { EditProductVariantsComponent } from '../edit-product-variants/edit-product-variants.component';
import { EditFilesComponent } from '../edit-files/edit-files.component';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { CommonService } from 'src/app/shared/common.service';
import { TranslateService } from '@ngx-translate/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ZodValidatorService } from 'src/app/shared/zod-validator/zod-validator.service';
import { step1Schema, step2Schema, step2VartiantsSchema } from '../../validators/product.zod.validator';
import { FilesDialogPreviewerComponent } from 'src/app/shared/files-dialog-previewer/files-dialog-previewer.component';
import { customValidator } from 'src/app/shared/validators/fields-validators';
import { FetchAllCurrencies } from 'src/app/features/customers/store/customers.actions';
import { ICurrency } from 'src/app/features/customers/models/customers.models';
import { LocalStorageService } from 'src/app/shared/localstorage.service';

export interface IAttribute {
  name: string;
  values: string[];
}
interface AddedCurrencyControl {
  data: ICurrency;
  variantId?: number;
  controls: {
    retail_price: FormGroup;
    cost: FormGroup;
  };
}
@Component({
  selector: 'app-add-produits',
  templateUrl: './add-produits.component.html',
  styleUrls: ['./add-produits.component.scss']
})
export class AddProduitsComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper | undefined;
  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild(CdkScrollable) scrollable!: CdkScrollable;
  @ViewChild('dropdown') dropdownRef!: ElementRef;
  @ViewChild('button') buttonRef!: ElementRef;
  public Editor = ClassicEditor;
  private destroy$ = new Subject<void>();
  private subscriptions: Subscription[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  addOnBlur = true;
  brand_id!: number;
  categories!: Array<ICategory>;
  tags: ITag[] = [];
  taxeValue!: string;
  brands$: Observable<IBrand[]> = of([]);
  filteredBrands$!: Observable<IBrand[]>;
  currencies$: Observable<ICurrency[]> = of([]);
  default_currency: ICurrency = LocalStorageService.get('currentUser')?.user?.currency!;
  currencies: ICurrency[] = [];
  tags$: Observable<ITag[]> = of([]);
  filteredTags$!: Observable<ITag[]>;
  categories$: Observable<ICategory[]> = of([]);
  filteredCategories$!: Observable<ICategory[]>;
  categoriesSelected$ = new BehaviorSubject<ICategory[]>([]);
  tagsSelected$ = new BehaviorSubject<ITag[]>([]);
  form!: FormGroup;
  generalRulesform!: FormGroup;
  variantsForm!: FormGroup;
  suppliersForm!: FormGroup;
  productType: string = 'standard';
  product!: IProduct;
  produitId!: number;
  currentProductId!: number;
  attrValues: string[] = [];
  uploadedImages: { id: number; file: File; preview: string, isDefault: boolean }[] = [];
  uploadedImage!: string;
  uploadedVariantImage: { [key: number]: string } = {};
  defaultVariantAvatar: string = '../../../../../assets/icones/drop_variant.svg';
  private imageCounter = 0;
  checkUpdate: boolean = false;
  attributes: IAttribute[] = [];
  suppliers: ISupplierProduct[] = [];
  variants: IVariant[] = [];
  canAddSupplierFlag = false;
  selectedCatalogs: ICatalog[] = [];
  currentForm: string = 'addProduct';
  selectedFiles: IFile[] = [];
  generalRules!: IGeneralRules;

  selectedValues: { [key: string]: string } = {};
  selectedVariant: IVariant | undefined = undefined;
  currentStep = 1;
  showCurrencyDropdown = false;
  availableCurrencies: ICurrency[] = [];
  addedCurrencies: AddedCurrencyControl[] = [];
  currenciesToDisplay: ICurrency[] = [];
  currenciesDropdown = {
    top: 0,
    left: 0,
    minWidth: 0
  };

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private store: Store<AppState>,
    private actions$: Actions,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private translateService: TranslateService,
    private zodValidatorService: ZodValidatorService
  ) {}


  ngOnInit() {
    this.initializeForm();
    this.initializeGeneralRulesForm();
    this.form.get('brandControl')?.valueChanges.subscribe(value => {
      if (typeof value === 'string' && value.trim() === '') {
        this.brand_id = 0
        this.form.get('brandControl')?.setValue(null, { emitEvent: false });
      }
    });
    this.variantsForm = this.fb.group({
      codes: this.fb.array([])
    });
    this.suppliersForm = this.fb.group({
    });
    if (!this.produitId) {
      setTimeout(() => {
        this.initializeFilters();
      }, 2);
    }
    // this.store.dispatch(FetchSuppliers());
    this.store.dispatch(FetchAllCurrencies());
    this.store.dispatch(FetchAllBrands({}));
    this.store.dispatch(FetchAllTags({}));
    this.store.dispatch(FetchAllCategories({}));
    this.store.dispatch(FetchAllCatalogs());
    this.currencies$ = this.store.select((state) => state.customers.allCurrencies);
    this.brands$ = this.store.select((state) => [...state.brands.allBrands].sort((a, b) => a.name.localeCompare(b.name)));
    this.tags$ = this.store.select((state) => [...state.tags.allTags].sort((a, b) => a.name.localeCompare(b.name)));
    this.categories$ = this.store.select((state) => [...state.categories.allCategories].sort((a, b) => a.name.localeCompare(b.name)))

    const sub2 = this.actions$.pipe(
      ofType(ImproveVariantsProductError),
      tap(() => {
        if (this.produitId) {
          this.store.dispatch(SetCurrentElementId({ currentElementId: this.produitId }))
          this.store.dispatch(GetProductById({ id: this.produitId }))
          }
        })
    ).subscribe();

    const sub3 = this.actions$.pipe(
        ofType(AddProductWithVariantsSuccess),
        tap((action) => {
        this.checkUpdate = true
        this.currentProductId = action.product.id!
          this.variants = action.product.variants!.map((val: IVariant) => {
            return {
              ...val,
              id: val.id,
              values: val.values.map((value: string) => {
              return value
              }),
              cost: val.cost,
              sales_price: val.sales_price,
              sku: val.sku,
            image: val.image
          }
        })
          this.attributes = this.attributes.map((attribute: IAttribute) => {
            return {
              ...attribute,
              name: attribute.name,
              values: attribute.values.map((value: string) => {
              return value
            })
          }
          });
        this.selectedValues = {}
          this.attributes.forEach((attribute) => {
          this.selectedValues[attribute.name] = attribute.values[0]
          });
          this.updateSelectedVariant();
          this.clearFormControls();
          this.variants.forEach((variant: IVariant, index) => {
          this.variantsForm.addControl(`sku_${variant.id}`, new FormControl('', [Validators.required]));
          this.variantsForm.addControl(`bar_code_${variant.id}`, new FormControl(variant.barcode ?? '', []));
          this.variantsForm.addControl(`cost_${variant.id}`, new FormControl(this.form.get('cost')?.value ?? null, []));
          this.variantsForm.addControl(`sales_price_${variant.id}`, new FormControl(this.form.get('sales_price')?.value ?? null, []));
          this.variantsForm.addControl(`quantity_${variant.id}`, new FormControl(variant.stock?.quantity ?? null));
          this.variantsForm.addControl(`reorder_point_${variant.id}`, new FormControl(variant.stock?.reorder_point ?? null, []));
          this.variantsForm.addControl(`reorder_quantity_${variant.id}`, new FormControl(variant.stock?.reorder_quantity ?? null, []));
          this.variantsForm.addControl(`enabled_${variant.id}`, new FormControl(variant.enabled ?? true, []));
          this.variantsForm.addControl(`expiry_date_${variant.id}`, new FormControl(variant.expiry_date ?? '', []));
          this.variantsForm.addControl(`increment_${variant.id}`, new FormControl(variant.increment ?? 1, []));
          this.variantsForm.addControl(`max_qte_${variant.id}`, new FormControl(variant.max_qte ?? null, []));
          this.variantsForm.addControl(`min_qte_${variant.id}`, new FormControl(variant.min_qte ?? 1, []));

            const codesArray = this.fb.array<FormGroup>([]);
            this.variantsForm.addControl(`codes_${variant.id}`, codesArray);

          const codes = Object.entries(variant.code_identifiers || {}).map(([key, value]) => ({
                label: key,
            value: value
          }))

            if (codes) {
              codes.forEach((code) => {
                codesArray.push(
                  this.fb.group({
                  label: new FormControl(code.label ?? '', [Validators.required]),
                  value: new FormControl(code.value ?? '', [Validators.required])
                  })
                );
              });
            }

          });
        })
    ).subscribe();

    const sub4 = this.actions$.pipe(
      ofType(AddProductSuccess, UpdateProductSuccess, ImproveVariantsProductSuccess, GetProductByIdError),
        tap(() => {
        this.router.navigate(['inventory'])
        })
    ).subscribe();

    const sub6 = this.actions$.pipe(
        ofType(AddBrandSuccess),
        tap((action) => {
          this.form.get('brandControl')?.setValue(action.brand.name);
        this.brand_id = action.brand.id
        })
    ).subscribe();

    const sub7 = this.actions$.pipe(
        ofType(AddBrandError),
        tap(() => {
          this.form.get('brandControl')?.setValue('');
        })
    ).subscribe();

    const sub8 = this.actions$.pipe(
        ofType(AddTagSuccess),
        tap((action) => {
          console.log("ici")
          this.form.get('tagControl')?.setValue('');
        this.tags = [...this.tags, action.tag]
        })
    ).subscribe();

    const sub9 = this.actions$.pipe(
        ofType(AddTagError),
        tap(() => {
          this.form.get('tagControl')?.setValue('');
        })
    ).subscribe();

    const sub10 = this.actions$.pipe(
        ofType(AddCategorySuccess),
        tap((action) => {
          //this.form.get('categoryControl')?.setValue(action.category.name);
          this.categories = action.categories;
        })
    ).subscribe();

    const sub11 = this.actions$.pipe(
        ofType(AddCategoryError),
        tap(() => {
          this.form.get('categoryControl')?.setValue('');
        })
    ).subscribe();
    this.setupFormListeners();
    const sub12 = this.currencies$.subscribe((currencies) => {
      this.currencies = currencies.filter(currency => !currency.is_default);
      this.availableCurrencies = this.currencies
    })
    this.subscriptions.push(sub2, sub3, sub4, sub6, sub7, sub8, sub9, sub10, sub11, sub12);
  }

  clearFormControls() {
    Object.keys(this.variantsForm.controls).forEach(controlName => {
      this.variantsForm.removeControl(controlName);
    });
  }

  clearSuppliersFormControls() {
    Object.keys(this.suppliersForm.controls).forEach(controlName => {
      this.suppliersForm.removeControl(controlName);
    });
  }

  private initializeForm(): void {
    this.form = this.fb.group({
      name: new FormControl(this.product?.name ?? '', Validators.required),
      codes: this.fb.array([]),
      status: new FormControl(this.product?.status ?? ''),
      tagControl: new FormControl(''),
      supplierControl: new FormControl(''),
      brandControl: new FormControl(this.product?.brand?.name ?? ''),
      categoryControl: new FormControl(this.product?.categories ?? []),
      barcodeControl: new FormControl(this.product?.barcode ?? ''),
      description: new FormControl(this.product?.description ?? ''),
      sku: new FormControl(this.product?.sku ?? '', Validators.required),
      quantity: new FormControl(this.product?.stock?.quantity ?? null,[Validators.max(9999999999)]),
      reorder_point: new FormControl(this.product?.stock?.reorder_point ?? null,[Validators.max(9999999999)]),
      reorder_quantity: new FormControl(this.product?.stock?.reorder_quantity ?? null,[Validators.max(9999999999)]),
      cost: new FormControl(this.product?.cost ?? null, [Validators.min(0)]),
      sales_price: new FormControl(this.product?.sales_price ?? null, [Validators.min(0)]),
      markup: new FormControl(),
      expiry_date: new FormControl(this.product?.expiry_date ?? null),
      // is_taxable: new FormControl(this.product?.is_taxable ?? ''),
    });
  }

  private initializeGeneralRulesForm(generalRules?: IGeneralRules): void {
      this.generalRulesform = this.fb.group({
        increment: new FormControl(generalRules?.increment ?? null),
        max_qte: new FormControl(generalRules?.max_qte ?? null),
        min_qte: new FormControl(generalRules?.min_qte ?? null),
      }, { validators: customValidator(this.translateService) });
    }

  initializeCodes(codes: { label: string; value: string }[]): void {
    this.codes.clear();
    codes.forEach((code) => {
      this.codes.push(
        this.fb.group({
          label: [code.label, Validators.required],
          value: [code.value, Validators.required]
        })
      );
    });
  }

  getCodesArray(variantId: number): FormArray<FormGroup> | null {
    return this.variantsForm.get(`codes_${variantId}`) as FormArray<FormGroup>;
  }

  addCodeToVariant(variantId: number): void {
    const codesArray = this.getCodesArray(variantId);
    if (codesArray) {
      codesArray.push(
        this.fb.group({
          label: ['', Validators.required],
          value: ['', Validators.required],
        })
      );
    }
  }
  sortedCategories(categories: any[]): any[] {
    if (!categories || !Array.isArray(categories)) return [];
    return [...categories].sort((a, b) =>
      (a.name || '').localeCompare(b.name || '')
    );
  }
  removeVariantCode(variantId: number, index: number): void {
    const codesArray = this.getCodesArray(variantId);
    if (codesArray && codesArray.length > 1) {
      codesArray.removeAt(index);
    } else {
      this.commonService.showToast(
        this.translateService.instant('inventory.least_code_must_be_present'),
        'WARNING'
      );
    }
  }

  private initializeFilters(): void {
    this.filteredTags$ = combineLatest([
      this.tags$,
      this.tagsSelected$,
      this.form.get('tagControl')!.valueChanges.pipe(startWith(''))
    ]).pipe(
      map(([allTags, selected, search]) => {
        const searchLower = search?.toLowerCase() || '';
        return allTags.filter(cat =>
          cat.name.toLowerCase().includes(searchLower) &&
          !selected.some(sel => sel.id === cat.id)
        );
      })
    );

    this.filteredCategories$ = combineLatest([
        this.categories$,
        this.categoriesSelected$,
        this.form.get('categoryControl')!.valueChanges.pipe(startWith(''))
      ]).pipe(
        map(([allCategories, selected, search]) => {
          const searchLower = search?.toLowerCase() || '';
          return allCategories.filter(cat =>
            cat.name.toLowerCase().includes(searchLower) &&
            !selected.some(sel => sel.id === cat.id)
          );
        })
      );

    this.filteredBrands$ = combineLatest([
      this.brands$,
      this.form.get('brandControl')!.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([brands, input]) => this._filterStrings(brands, input))
    );
  }

  private _filterStrings(strings: any[], value: string): any[] {
    const filterValue = this._normalizeValue(value);
    return strings.filter((string) =>
      this._normalizeValue(string.name)?.includes(filterValue!)
    );
  }

  private _normalizeValue(value: string | undefined): string | undefined {
    return value?.toLowerCase().replace(/\s/g, '');
  }

  get codes(): FormArray {
    return this.form.get('codes') as FormArray;
  }

  addCode(): void {
    this.codes.push(
      this.fb.group({
        label: ['', Validators.required],
        value: ['', Validators.required]
      })
    );
  }

  removeCode(index: number): void {
    this.codes.removeAt(index);
  }

  back(){
    this.currentStep = this.stepper ? this.stepper?.selectedIndex + 1 : 0;
    this.stepper?.previous();
    this.scrollable.scrollTo({ top: 0, behavior: 'smooth' });
  }

  cancelCategory(id: number) {
    const current = this.categoriesSelected$.getValue();
    const updated = current.filter(cat => cat.id !== id);
    this.categoriesSelected$.next(updated);
  }

  next(type?: string): boolean | void {
    if(type && type === 'basic_infos' && this.form.get('name')?.invalid){
      this.form.get('name')?.markAsTouched();
      return false
    }
    if(type && type === 'standard_inventory' && (this.form.get('sales_price')?.invalid || this.form.get('cost')?.invalid || this.form.get('sku')?.invalid || this.codes?.invalid)){
      this.form.get('sales_price')?.markAsTouched();
      this.form.get('cost')?.markAsTouched();
      this.form.get('sku')?.markAsTouched();
      this.codes.markAllAsTouched();
      return false
    }
    if (type && type === 'standard_inventory' && this.generalRulesform.invalid) {
      this.generalRulesform.markAllAsTouched();
      return false
    }
    if(type && type === 'variants_step' && this.variants.length === 0){
      this.commonService.showToast(
        this.translateService.instant('inventory.alert_generate_variants'),
        'WARNING'
      );
      return false
    }
    if(type && type === 'variants_step' && this.variants.length !== 0 && this.variantsForm.invalid) {
      this.commonService.showToast(
        this.translateService.instant(
          'inventory.alert_required_attributs_variants'
        ),
        'WARNING'
      );
      return false
    }
    if (type && type === 'variants_step' && this.variants && this.variants.length !== 0 && !this.validateVariantsQuantityBeforeSave()){
      return  false;
    }

    if(this.isStepValid()) {
      this.stepper?.next();
      this.scrollable.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  isStepValid() {
    this.currentStep = this.stepper ? this.stepper?.selectedIndex + 1 : 0; // If stepper is undefined set currentStep to an unkown step so the stepValidation get bypassed
    return this.validateStep(this.currentStep)
  }

  validateStep(step: number) {
    let stepSchema : any = null;
    let stepData : any = null;
    let isVariant: boolean = false;

    if(step === 1) {
      stepData = {
        name: this.form.getRawValue()?.name,
        images: this.uploadedImages,
        files: this.selectedFiles
      }

      stepSchema = step1Schema
    }

    if(step === 2) {
      if(this.variants.length === 0) {
        stepData = {
          sales_price: this.form.getRawValue()?.sales_price,
          cost: this.form.getRawValue()?.cost,
          sku: this.form.getRawValue()?.sku
        }
        stepSchema = step2Schema
      }
      else {
        isVariant = true
        stepData = this.resovleVariants({ returnImageAsString: false });
        stepSchema = step2VartiantsSchema
      }

    }

    if(step === 3) {
      return true;
    }

    if(step === 4) {
      return true;
    }

    if(stepSchema && stepData) {
      const result = this.zodValidatorService.validate(stepSchema, stepData, {returnErrors: false, translationKey: 'product.step' + step + (isVariant ? '_variants' : '') })
      return result.success
    }

    return true;
  }

  cancel() {
    this.router.navigate(['inventory'], {
      queryParamsHandling: 'merge',
    })
  }

  sanitize(event: any) {
    event.target.value = event.target.value.replace(/[^\d]/g, '');
  }
  sanitizePrice(event: any) {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
  }
  selectAttributeValue(attribute: string, value: string): void {
    this.selectedValues[attribute] = value;
    this.updateSelectedVariant();
  }

  isSelected(attribute: string, value: string): boolean {
    return this.selectedValues[attribute] === value;
  }

  updateSelectedVariant(): void {
    const selectedAttributes = Object.values(this.selectedValues);
    this.selectedVariant = this.variants.find(variant =>
      selectedAttributes.every(val => variant.values.includes(val))
    );
  }

  onBrandSelected(brand: IBrand) {
    if (brand) {
      this.brand_id = brand.id
    }
  }

  onTagSelected(tag: ITag) {
    if (tag) {
      const current = this.tagsSelected$.getValue();
      if (!current.some(c => c.id === tag.id)) {
        this.tagsSelected$.next([...current, tag]);
      }
    }
    this.form.get('tagControl')?.setValue('');
  }

  onCategorySelected(category: ICategory) {
    if (category) {
      const current = this.categoriesSelected$.getValue();
      if (!current.some(c => c.id === category.id)) {
        this.categoriesSelected$.next([...current, category]);
      }
    }
    this.form.get('categoryControl')?.setValue('');
  }

  goTo(form: string){
    this.currentForm = form;
  }

  onSaveCatalogs(selectedCatalogs: ICatalog[]){
    this.selectedCatalogs = selectedCatalogs;
    this.currentForm = 'addProduct';
  }

  removeCatalog(id: number){
    this.selectedCatalogs = this.selectedCatalogs.filter((catalog: ICatalog) => catalog.id !== id)
  }

  canceled(){
    this.currentForm = 'addProduct';
  }

  addNewElement(newElementName: string, type: string, index?: number) {

    const dialogRef = this.dialog.open(AddElementsComponent, {
      data: {
        name: newElementName,
        type: type,
        index: index
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.autocompleteTriggers.forEach(trigger => trigger.closePanel());
    });
  }

  cancelTag(id: number) {
    this.tags = this.tags.filter((tag) => tag.id !== id)
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.remove('drag-over');
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.remove('drag-over');

    const files = event.dataTransfer?.files;
    if (files) {
      this.processFiles(files);
    }
  }

  setupFormListeners(): void {
    // this.form.get('cost')?.valueChanges
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((cost) => {
    //     // Ensure cost is at least 0
    //     if (cost < 0) {
    //       this.form.get('cost')?.setValue(0, { emitEvent: false });
    //       return;
    //     }
    //     this.form.get('markup')?.setValue('', { emitEvent: false });
    //     this.form.get('sales_price')?.setValue('', { emitEvent: false });
    //     this.taxeValue = ''
    //   });

    // this.form.get('sales_price')?.valueChanges
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((salesPrice) => {
    //     const cost = this.form.get('cost')?.value;
    //     const PH = salesPrice / 1.2
    //     this.taxeValue = (PH * 0.2).toFixed(2)
    //     const markup = (((PH - cost) / cost) * 100);
    //     this.form.get('markup')?.setValue(markup.toFixed(2), { emitEvent: false });
    //   });

    // this.form.get('markup')?.valueChanges
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((markup) => {
    //     if (markup < 0) {
    //       this.form.get('markup')?.setValue(0, { emitEvent: false });
    //       return;
    //     }

    //     const cost = this.form.get('cost')?.value;
    //     const PH = (1 + markup / 100) * cost
    //     this.taxeValue = (PH * 0.2).toFixed(2)
    //     const salesPrice = PH * 1.2;
    //     this.form.get('sales_price')?.setValue(salesPrice.toFixed(2), { emitEvent: false });
    //   });
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (files) {
      this.processFiles(files);
    }
  }

  processFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        const previewData = e.target?.result as string;
        const hasDefault = this.uploadedImages.filter((image: any) => image.isDefault).length

        this.uploadedImages.push({
          id: this.imageCounter++,
          file,
          preview: previewData,
          isDefault: hasDefault ? false : true,
        });

        this.uploadedImages.sort((a, b) => {
            if (b.isDefault !== a.isDefault) {
                return b.isDefault ? 1 : -1;
            }
            return a.id - b.id;
        });
      };
      reader.readAsDataURL(file);
    }
  }

  cancelImage(){
    this.uploadedImage = ''
    this.uploadedImages = []
  }

  removeImage(imageId: number) {
    const imageToRemove = this.uploadedImages.find(image => image.id === imageId);

    if (imageToRemove && imageToRemove.isDefault) {
      const newDefault = this.uploadedImages.find(image => image.id !== imageId && !image.isDefault);

      if (newDefault) {
        newDefault.isDefault = true;
      }
    }

    this.uploadedImages = this.uploadedImages.filter(image => image.id !== imageId);
  }

  removeAllImages() {
    this.uploadedImages = [];
  }

  getDefaultImage() {
    const defaultImage = this.uploadedImages.find(image => image.isDefault);
    return defaultImage ? defaultImage.preview.split(',')[1] : undefined;
  }

  setDefault(imageId: number) {
    this.uploadedImages = this.uploadedImages.map((image) => {
      image.isDefault = image.id === imageId ? true : false;

      return image;
    });
  }

  changeTypeProduct(type: string): boolean | void {
    if (this.productType === type || this.produitId || this.variants.length > 0) {
      return false
    }
    this.productType = type;

    this.form.get('sku')?.clearValidators();
    this.form.get('sales_price')?.clearValidators();
    this.form.get('cost')?.clearValidators();

    if (type === 'variante') {
      this.attributes.push({ name: '', values: [] });
    } else if (type === 'standard') {
      this.attributes = [];
      this.selectedValues = {}
      this.updateSelectedVariant();
      this.form.get('sku')?.setValidators([Validators.required]);
      this.form.get('sales_price')?.setValidators([]);
      this.form.get('cost')?.setValidators([]);
    }

    this.form.get('sku')?.updateValueAndValidity();
    this.form.get('sales_price')?.updateValueAndValidity();
    this.form.get('cost')?.updateValueAndValidity();
  }

  removeSupplier(index: number) {
    this.suppliersForm.removeControl(`supplierControl_${index}`)
    this.suppliers.splice(index, 1)
  }

  addAttribute() {
    const invalidAttribute = this.attributes.find(attribute => !attribute.name || attribute.values.length <= 1);
    if (invalidAttribute) {
      this.commonService.showToast(
        this.translateService.instant('inventory.alert_invalid_attribut'),
        'WARNING'
      );
      return;
    }

    if (this.attributes.length < 3) {
      this.attributes.push({ name: '', values: [] })
      this.checkUpdate = false
    } else {
      this.commonService.showToast(
        this.translateService.instant('inventory.alert_max_three_attributs'),
        'WARNING'
      );
    }
  }

  removeAttr(attributeIndex: number) {
    this.attributes.splice(attributeIndex, 1);
    this.checkUpdate = false
  }

  addValue(event: any, attrIndex: number) {
    const value = event.value.trim();
    if (value && !this.attributes[attrIndex].values.includes(value)) {
      this.attributes[attrIndex].values.push(value)
      this.checkUpdate = false
    }
    event.chipInput!.clear();
  }

  updateAttributeName(event: any) {
    const name = event.target.value
    if (event.target.value) {
      this.checkUpdate = false
    }
  }

  removeValue(attributeIndex: number, valueIndex: number) {
    this.attributes[attributeIndex].values.splice(valueIndex, 1)
    this.checkUpdate = false
  }

  generateVariants(): boolean | void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false
    }
    const invalidAttribute = this.attributes.find(attribute => !attribute.name || attribute.values.length <= 1);
    if (invalidAttribute) {
      this.commonService.showToast(
        this.translateService.instant('inventory.alert_invalid_attribut'),
        'WARNING'
      );
      return;
    } else {
      // this.variants = this.generateVariantsRecursive(this.attributes);
      const tag_ids: number[] = []
      this.tags.forEach(tag => {
        tag_ids.push(tag.id)
      });

      const parsedImages = this.uploadedImages.map((img: any) => {
        return { image: img.preview.split(',')[1], default: img.isDefault }
      })

      const payload: Omit<IProduct, 'sku'> = {
        name: this.form.get('name')?.value,
        status: this.form.get('status')?.value,
        brand_id: this.brand_id ?? '',
        barcode: this.form.get('barcodeControl')?.value,
        description: this.form.get('description')?.value,
        categories: this.categories ?? [],
        tag_ids: tag_ids,
        cost: this.form.get('cost')?.value,
        sales_price: this.form.get('sales_price')?.value,
        // image: this.getDefaultImage(),
        images: parsedImages,
        attributes: this.attributes,
        catalog_ids: this.selectedCatalogs.map(catalog => catalog.id),
        expiry_date: this.form.get('expiry_date')?.value
      }

      if (this.variants.length > 0) {
        const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
          data: {
            text: this.translateService.instant('inventory.alert_regenerate_attributs'),
            icon: '../../../assets/icones/low-warning-100X100.svg',
            confirm_text: this.translateService.instant('common.confirm'),
            confirm_class: "btn-warning"
          }
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
          if (result) {
            this.store.dispatch(AddProductWithVariants({ product: payload }));
          }
        });
        return;
      } else {
        this.store.dispatch(AddProductWithVariants({ product: payload }));
      }
      this.attributes = this.attributes.map((attribute: IAttribute) => {
        return {
          ...attribute,
          name: attribute.name,
          values: attribute.values.map((value: string) => {
            return value
          })
        }
      });
      this.selectedValues = {}
      this.attributes.forEach((attribute) => {
        this.selectedValues[attribute.name] = attribute.values[0]
      });
      this.updateSelectedVariant();
    }
  }

  getVariantImg(event: any, variantId: number) {
    let file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const dataUrl = e.target.result
        const variant = this.variants.find(variant => variant.id === variantId);

        if(variant) {
          variant.image = dataUrl.split(',')[1]
          variant.imageObject = {
            file,
          }
        }
        this.variants.find(variant => variant.id === variantId)!.image = dataUrl.split(',')[1]
      };
      reader.readAsDataURL(file);
    }
  }

  cancelImageVariant(variantId: number) {
    this.variants.find(variant => variant.id === variantId)!.image = '';
    this.variants.find(variant => variant.id === variantId)!.imageObject = undefined;
  }

  editBasicInfo(){
    const dialogRef = this.dialog.open(EditBasicProductInfoComponent, {
      data: {
        images: this.uploadedImages,
        name: this.form.get('name')?.value,
        status: this.form.get('status')?.value,
        description: this.form.get('description')?.value,
        brandControl: this.form.get('brandControl')?.value,
        brand_id: this.brand_id,
        productType: this.productType
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.uploadedImage = result.image;
        this.form.get('name')?.setValue(result.name);
        this.form.get('status')?.setValue(result.status);
        this.form.get('description')?.setValue(result.description);
        this.form.get('brandControl')?.setValue(result.brandControl);
        this.brand_id = result.brand_id;
      }
    });
  }

  editPricingProduct(){
    const dialogRef = this.dialog.open(EditProductPricingComponent, {
      data: {
        sales_price: this.form.get('sales_price')?.value,
        cost: this.form.get('cost')?.value,
        currencyPrices: this.addedCurrencies?.flatMap(c => [
          {
            currency_id: c.controls.retail_price.value.currency_id,
            type: c.controls.retail_price.value.type,
            amount: c.controls.retail_price.value.amount
          },
          {
            currency_id: c.controls.cost.value.currency_id,
            type: c.controls.cost.value.type,
            amount: c.controls.cost.value.amount
          }
        ]),
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.form.get('sales_price')?.setValue(result.sales_price);
        this.form.get('cost')?.setValue(result.cost);
        this.addedCurrencies = result.addedCurrencies;
      }
    });
  }

  editInventoryProduct(){
    const dialogRef = this.dialog.open(EditProductInventoryComponent, {
      data: {
        sku: this.form.get('sku')?.value,
        barcodeControl: this.form.get('barcodeControl')?.value,
        quantity: this.form.get('quantity')?.value,
        reorder_point: this.form.get('reorder_point')?.value,
        codes: this.form.get('codes')?.value,
        expiry_date: this.form.get('expiry_date')?.value,
        max_qte: this.generalRulesform.get('max_qte')?.value,
        min_qte: this.generalRulesform.get('min_qte')?.value,
        increment: this.generalRulesform.get('increment')?.value,
        translate: this.translateService
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.initializeCodes(result.codes);
        this.form.get('sku')?.setValue(result.sku);
        this.form.get('barcodeControl')?.setValue(result.barcodeControl);
        this.form.get('quantity')?.setValue(result.quantity);
        this.form.get('reorder_point')?.setValue(result.reorder_point);
        this.form.get('can_be_sold_out_of_stock')?.setValue(result.can_be_sold_out_of_stock);
        this.generalRulesform.get('max_qte')?.setValue(result.max_qte);
        this.generalRulesform.get('min_qte')?.setValue(result.min_qte);
        this.generalRulesform.get('increment')?.setValue(result.increment);
      }
    });
  }

  editVariantProduct(){
    const variants = this.variants.map((variant: IVariant) => {
      return {
        id: variant.id,
        sku: this.variantsForm.get(`sku_${variant.id}`)?.value,
        barcode: this.variantsForm.get(`bar_code_${variant.id}`)?.value,
        cost: this.variantsForm.get(`cost_${variant.id}`)?.value,
        sales_price: this.variantsForm.get(`sales_price_${variant.id}`)?.value,
        expiry_date: this.variantsForm.get(`expiry_date_${variant.id}`)?.value,
        stock: {
          quantity: this.variantsForm.get(`quantity_${variant.id}`)?.value,
          reorder_point: this.variantsForm.get(`reorder_point_${variant.id}`)?.value,
          reorder_quantity: this.variantsForm.get(`reorder_quantity_${variant.id}`)?.value,
        },
        image: variant.image,
        values: variant.values,
        enabled: this.variantsForm.get(`enabled_${variant.id}`)?.value,
        codes: this.variantsForm.get(`codes_${variant.id}`)?.value,
        max_qte: this.variantsForm.get(`max_qte_${variant.id}`)?.value,
        min_qte: this.variantsForm.get(`min_qte_${variant.id}`)?.value,
        increment: this.variantsForm.get(`increment_${variant.id}`)?.value,
        currency_prices: this.addedCurrencies
        .filter(c => c.variantId === variant.id)
        .flatMap(c => [
          {
            currency_id: c.controls.retail_price.value.currency_id,
            type: c.controls.retail_price.value.type,
            amount: c.controls.retail_price.value.amount
          },
          {
            currency_id: c.controls.cost.value.currency_id,
            type: c.controls.cost.value.type,
            amount: c.controls.cost.value.amount
          }
        ])
      };
    });
    const dialogRef = this.dialog.open(EditProductVariantsComponent, {
      data: {
        variants: variants,
        attributes: this.attributes
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {      
        this.variants = result.variants?.map((val: IVariant) => {
          return {
            ...val,
            id: val.id,
            values: val.values.map((value: string) => {
              return value
            }),
            cost: val.cost,
            sales_price: val.sales_price,
            sku: val.sku,
            image: val.image,
            codes: val.codes
          }
        }),
        this.addedCurrencies = result.addedCurrencies;
        this.clearFormControls();
        this.variants.forEach((variant: IVariant) => {
          this.variantsForm.addControl(`sku_${variant.id}`, new FormControl(variant.sku ?? '', [Validators.required]));
          this.variantsForm.addControl(`bar_code_${variant.id}`, new FormControl(variant.barcode ?? '', []));
          this.variantsForm.addControl(`cost_${variant.id}`, new FormControl(variant.cost ?? null, [Validators.min(0)]));
          this.variantsForm.addControl(`sales_price_${variant.id}`, new FormControl(variant.sales_price ?? null, [Validators.min(0), Validators.required]));
          this.variantsForm.addControl(`quantity_${variant.id}`, new FormControl(variant.stock?.quantity ?? null, [Validators.required, Validators.max(9999999999)]));
          this.variantsForm.addControl(`reorder_point_${variant.id}`, new FormControl(variant.stock?.reorder_point ?? null, [Validators.max(9999999999)]));
          this.variantsForm.addControl(`reorder_quantity_${variant.id}`, new FormControl(variant.stock?.reorder_quantity ?? '', []));
          this.variantsForm.addControl(`enabled_${variant.id}`, new FormControl(variant.enabled ?? '', []));
          this.variantsForm.addControl(`expiry_date_${variant.id}`, new FormControl(variant.expiry_date ?? '', []));
          this.variantsForm.addControl(`increment_${variant.id}`, new FormControl(variant.increment ?? 1, []));
          this.variantsForm.addControl(`max_qte_${variant.id}`, new FormControl(variant.max_qte ?? null, []));
          this.variantsForm.addControl(`min_qte_${variant.id}`, new FormControl(variant.min_qte ?? 1, []));
          const codesArray = this.fb.array<FormGroup>([]);
          this.variantsForm.addControl(`codes_${variant.id}`, codesArray);
          if (variant.codes) {
            variant.codes.forEach((code) => {
              codesArray.push(
                this.fb.group({
                  label: new FormControl(code.label ?? '', [Validators.required]),
                  value: new FormControl(code.value ?? '', [Validators.required])
                })
              );
            });
          }
        });
      }
    });
  }

  editOrganizeProduct(){
    const dialogRef = this.dialog.open(EditProductOrganizeComponent, {
      data: {
        sku: this.form.get('sku')?.value,
        categoryControl: this.form.get('categoryControl')?.value,
        tagControl: this.form.get('tagControl')?.value,
        tags: this.tags,
        categories: this.categories
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.form.get('categoryControl')?.setValue(result.categoryControl);
        this.form.get('tagControl')?.setValue(result.tagControl);
        this.categories = result.categories;
        this.tagsSelected$.next(result.tags);
      }
    });
  }

  addFiles(event: any): void {
    const files = event.target.files as FileList;
    if (files && files.length > 0) {
      Array.from(files).forEach((file: File) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = reader.result as string;
          this.selectedFiles.push({
            data: base64Data.split(',')[1],
            filename: file.name,
            content_type: file.type,
            file: file,
          });
        };
        reader.readAsDataURL(file);
      });
    }
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  editFiles(files: IFile[]): void {
    const dialogRef = this.dialog.open(EditFilesComponent, {
      data: { files },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: IFile[]) => {

      if (result) {
        this.selectedFiles = [...result];
      }
    });
  }

  resovleVariants(flags = { returnImageAsString: true }) {
    const variants: Omit<IVariant, 'values'>[] = this.variants.map((variant: IVariant, index) => {

      const payload: any = {
        id: variant.id,
        sku: this.variantsForm.get(`sku_${variant.id}`)?.value,
        barcode: this.variantsForm.get(`bar_code_${variant.id}`)?.value,
        cost: this.variantsForm.get(`cost_${variant.id}`)?.value,
        sales_price: this.variantsForm.get(`sales_price_${variant.id}`)?.value,
        expiry_date: this.variantsForm.get(`expiry_date_${variant.id}`)?.value,
        stock: {
          quantity: this.variantsForm.get(`quantity_${variant.id}`)?.value,
          reorder_point: this.variantsForm.get(`reorder_point_${variant.id}`)?.value,
          reorder_quantity: this.variantsForm.get(`reorder_quantity_${variant.id}`)?.value,
        },
        max_qte: this.variantsForm.get(`max_qte_${variant.id}`)?.value,
        min_qte: this.variantsForm.get(`min_qte_${variant.id}`)?.value,
        increment: this.variantsForm.get(`increment_${variant.id}`)?.value,
        enabled: this.variantsForm.get(`enabled_${variant.id}`)?.value,
        // code_identifiers: this.variantsForm.get(`codes_${variant.id}`)?.value.reduce((acc: any, code: any) => {
        //     acc[code.label] = code.value;
        //     return acc;
        // }, {}),
        currency_prices: this.addedCurrencies
        .filter(c => c.variantId === variant.id)
        .flatMap(c => [
          {
            currency_id: c.controls.retail_price.value.currency_id,
            type: c.controls.retail_price.value.type,
            amount: c.controls.retail_price.value.amount
          },
          {
            currency_id: c.controls.cost.value.currency_id,
            type: c.controls.cost.value.type,
            amount: c.controls.cost.value.amount
          }
        ])
      };

      payload.image = flags.returnImageAsString ? variant.image : variant.imageObject;

      return payload;
    });

    return variants;
  }

  submitPermission() {
    return { module: 'product', action: this.product ? 'edit' : 'create' };
  }

  save(): boolean | void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false
    }

    // Check if any of the steps that need validation are invalid
    const isSomeStepInvalid = [1, 2].some((step: number) => !this.validateStep(step))

    if(isSomeStepInvalid) {
      return; // Exit if any step is invalid
    }

    const parsedImages = this.uploadedImages.map((img: any) => {
      return { image: img.preview.split(',')[1], default: img.isDefault }
    })

    if (this.productType === 'variante') {
      if (this.variants.length > 0) {

        if (this.variantsForm.invalid) {
          this.commonService.showToast(
            this.translateService.instant(
              'inventory.alert_variant_form_invalid'
            ),
            'WARNING'
          );
        } else {
          const variants: Omit<IVariant, 'values'>[] = this.resovleVariants()

          const tag_ids: number[] = []
          this.tagsSelected$.getValue().forEach(tag => {
            tag_ids.push(tag.id)
          });

          const payload: Omit<IProduct, 'sku'> = {
            name: this.form.get('name')?.value,
            status: this.form.get('status')?.value,
            brand_id: this.brand_id ?? '',
            barcode: this.form.get('barcodeControl')?.value,
            description: this.form.get('description')?.value,
            category_ids: this.categoriesSelected$.getValue()!.map((category) => category.id),
            tag_ids: tag_ids,
            cost: this.form.get('cost')?.value,
            sales_price: this.form.get('sales_price')?.value,
            images: parsedImages,
            catalog_ids: this.selectedCatalogs.map(catalog => catalog.id),
            expiry_date: this.form.get('expiry_date')?.value,

            // is_taxable: this.form.get('is_taxable')?.value,
          }
          const isInvalidSupplier = this.suppliers.find((supplier) => !supplier.supplier_id)
          if (this.suppliers.length > 0 && !isInvalidSupplier) {
            payload.suppliers = this.suppliers;
            payload.current_supplier_id = this.suppliers[0].supplier_id
          }
          if (this.product) {
            this.store.dispatch(UpdateVariantsProduct({ id: this.product.id!, product: payload }));
            this.store.dispatch(ImproveVariantsProduct({ variants: variants }));
          } else {
            this.store.dispatch(ImproveVariantsProduct({ variants: variants, product: payload, idProduct: this.currentProductId }));
          }

        }
        return
      } else {
        this.commonService.showToast(
          this.translateService.instant('inventory.alert_generate_variants'),
          'WARNING'
        );
        return
      }

    } else {
      const tag_ids: number[] = []
      this.tagsSelected$.getValue().forEach(tag => {
        tag_ids.push(tag.id)
      });


      const payload: IProduct = {
        name: this.form.get('name')?.value,
        status: this.form.get('status')?.value,
        sku: this.form.get('sku')?.value,
        brand_id: this.brand_id ?? '',
        max_qte: this.generalRulesform.get('max_qte')?.value,
        min_qte: this.generalRulesform.get('min_qte')?.value,
        increment: this.generalRulesform.get('increment')?.value,
        barcode: this.form.get('barcodeControl')?.value,
        description: this.form.get('description')?.value,
        category_ids: this.categoriesSelected$.getValue()!.map((category) => category.id),
        tag_ids: tag_ids,
        expiry_date: this.form.get('expiry_date')?.value,
        stock: {
          quantity: this.form.get('quantity')?.value,
          reorder_point: this.form.get('reorder_point')?.value,
          reorder_quantity: this.form.get('reorder_quantity')?.value
        },
        cost: this.form.get('cost')?.value,
        sales_price: this.form.get('sales_price')?.value,
        images: parsedImages,
        catalog_ids: this.selectedCatalogs.map(catalog => catalog.id),
        files: this.selectedFiles,
        code_identifiers: this.form.get('codes')?.value.reduce((acc: any, code: any) => {
            acc[code.label] = code.value;
            return acc;
        }, {}),
        currency_prices: this.addedCurrencies.flatMap(c => [
          {
            currency_id: c.controls.retail_price.value.currency_id,
            type: c.controls.retail_price.value.type,
            amount: c.controls.retail_price.value.amount
          },
          {
            currency_id: c.controls.cost.value.currency_id,
            type: c.controls.cost.value.type,
            amount: c.controls.cost.value.amount
          }
        ])


        //   "code_identifiers": {
        //     "product_code": 123123
        // }
        // is_taxable: this.form.get('is_taxable')?.value,

      };
      const isInvalidSupplier = this.suppliers.find((supplier) => !supplier.supplier_id)
      if (this.suppliers.length > 0 && !isInvalidSupplier) {
        payload.suppliers = this.suppliers;
        payload.current_supplier_id = this.suppliers[0].supplier_id
      }
      if (this.product) {
        this.store.dispatch(UpdateProduct({ id: this.product.id, product: payload }))
      } else {
        this.store.dispatch(AddProduct({ product: payload }))
      }
    }
    this.suppliers = this.suppliers.map((supplier: ISupplierProduct) => {
      return {
        ...supplier
      }
    })
  }
  private convertBase64ToBlob(data: string, content_type: string): Blob {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: content_type });
  }

  download(data: string, fileName: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }
  preview(data: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    this.dialog.open(FilesDialogPreviewerComponent, {
      data: [blob]
    })
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }

  validateVariantsQuantityBeforeSave(): boolean {
    for (const variant of this.variants) {
      const min = this.variantsForm.get(`min_qte_${variant.id}`)?.value;
      const max = this.variantsForm.get(`max_qte_${variant.id}`)?.value;
      const inc = this.variantsForm.get(`increment_${variant.id}`)?.value;
      const sku = this.variantsForm.get(`sku_${variant.id}`)?.value

      if (min != null && min < 1) {
        this.commonService.showToast(
          this.translateService.instant(
            'Catalogs.validators.min_qte_greater_equal_one'
          ) + ' SKU: ' + sku,
          'WARNING'
        );
        return false;
      }

      if (inc != null && inc < 1) {
        this.commonService.showToast(
          this.translateService.instant(
            'Catalogs.validators.increment_greater_equal_one'
          ) + ' SKU: ' + sku,
          'WARNING'
        );
        return false;
      }

      if (min != null && max != null && min >= max) {
         this.commonService.showToast(
          this.translateService.instant(
            'Catalogs.validators.min_less_than_max'
          ) + ' SKU: ' + sku,
          'WARNING'
        );
        return false;
      }

      if (inc != null && min != null && inc > min) {
         this.commonService.showToast(
          this.translateService.instant(
            'Catalogs.validators.increment_less_than_or_equal_min'
          ) + ' SKU: ' + sku,
          'WARNING'
        );
        return false;
      }
    }

    return true;
  }

  getPricesForSelectedVariant(type: 'retail_price' | 'cost') {
    return this.addedCurrencies
      .filter(currency => currency.variantId === this.selectedVariant?.id)
      .map(currency => ({
        amount: currency.controls[type]?.get('amount')?.value,
        currencySymbol: currency.data?.symbol || '?'
      }));
  }

  addCurrency(currency: ICurrency): void {
    const createControls = (currency: ICurrency, variant_id: number = 0) => ({
      retail_price: this.fb.group({
        variant_id: [variant_id],
        currency_id: [currency.id, Validators.required],
        type: ['retail_price'],
        amount: [null, Validators.min(0)],
        name: [currency.name],
        symbol: [currency.symbol]
      }),
      cost: this.fb.group({
        variant_id: [variant_id],
        currency_id: [currency.id, Validators.required],
        type: ['cost'],
        amount: [null, Validators.min(0)],
        name: [currency.name],
        symbol: [currency.symbol]
      })
    });

    if (this.variants.length === 0) {
      this.addedCurrencies.push({
        data: currency,
        controls: createControls(currency)
      });
    } else {
      this.variants.forEach(variant => {
      const currencyExists = this.addedCurrencies.some(c => c.variantId === variant.id && c.data.id === currency.id);
      if (!currencyExists) {
        this.addedCurrencies.push({
          data: currency,
          variantId: variant.id,
          controls: createControls(currency, variant.id)
        });
      }
    });
    }
    this.availableCurrencies = this.availableCurrencies.filter(c => c.id !== currency.id);
    this.showCurrencyDropdown = false;
    if(!this.currenciesToDisplay.map(c => c.id).includes(currency.id)) this.currenciesToDisplay.push(currency);
  }

  removeCurrency(currencyId: number): void {
    const index = this.addedCurrencies.findIndex(c => c.data.id === currencyId);
    if (index > -1) {
      this.availableCurrencies.push(this.addedCurrencies[index].data);
      this.addedCurrencies = this.addedCurrencies.filter(c => c.data.id !== currencyId);
    }
    this.currenciesToDisplay = this.currenciesToDisplay.filter(c => c.id !== currencyId);
  }

  openCurrenciesDropdown(event: MouseEvent): void {
    const button = event.currentTarget as HTMLElement;
    const rect = button.getBoundingClientRect();

    this.currenciesDropdown = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      minWidth: rect.width
    };

    this.showCurrencyDropdown = true;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInsideDropdown = this.dropdownRef?.nativeElement.contains(event.target);
    const clickedButton = this.buttonRef?.nativeElement.contains(event.target);

    if (!clickedInsideDropdown && !clickedButton) {
      this.showCurrencyDropdown = false;
    }
  }
}

